import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { FlyoutOpeningData, PersonDetails, SessionAction, SessionActionType, SessionDetails } from '../flyout-models';
import { FlyoutService } from '../flyout.service';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../core/language.service';
import { Account } from '../../back-office/account.model';
import { AccountService } from 'app/account/account.service';

@Component({
  selector: 'app-flyout-action-list',
  templateUrl: './flyout-action-list.component.html',
  styleUrls: ['./flyout-action-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutActionListComponent implements OnInit, OnDestroy {
  private readonly logger: Logger;
  private _openingData: FlyoutOpeningData;
  private _accountDetails: Account;
  public personDetails: PersonDetails;
  private personSubscription: Subscription;
  private sessionDetails: SessionDetails;
  private sessionSubscription: Subscription;
  private subscriptionArray: Subscription[] = [];
  public sessionActions: Array<SessionAction>;
  public SessionActionTypes = SessionActionType;
  public expandedTab: string;
  @Input() public isMobile = false;

  @Input() public set flyoutOpeningData(openingData: FlyoutOpeningData) {
    this.expandedTab = openingData.expandedTab;
    this._openingData = openingData;
  }

  public get flyoutOpeningData(): FlyoutOpeningData {
    return this._openingData;
  }

  constructor(
    public readonly loggerFactory: LoggerFactory,
    private readonly flyoutService: FlyoutService,
    private readonly languageService: LanguageService,
    private readonly accountService: AccountService,
  ) {
    this.logger = loggerFactory.get('FlyoutActionListComponent');
  }

  async ngOnInit() {
    this._accountDetails = await this.accountService.getCurrentAccountAsync();
    this.sessionSubscription = this.flyoutService.sessionDetailsBS.subscribe((sessionDetails: SessionDetails) => {
      this.sessionDetails = sessionDetails;
      this.processStatistics();
    });
    this.personSubscription = this.flyoutService.personDetailsBS.subscribe((personDetails: PersonDetails) => {
      this.personDetails = personDetails;
      this.processStatistics();
    });
  }

  private processStatistics() {
    if (this.sessionDetails && this.sessionDetails.actionsList) {
      const sessionActions = JSON.parse(JSON.stringify(this.sessionDetails.actionsList));
      if (sessionActions) {
        sessionActions.forEach((action: SessionAction) => {
          if (action.title === 'gave consent') {
            action.title = this.languageService.translateInstantly('flyout.actionList.gaveConsent');
          }
          if (action.title === 'widget-conversion-partial') {
            action.title =
              this.languageService.translateInstantly('flyout.actionList.widget-conversion-partial') +
              ':' +
              ' ' +
              action.title;
          }
          if (action.title === 'widget-survey-response-partial') {
            action.title =
              this.languageService.translateInstantly('flyout.actionList.widget-survey-response-partial') +
              ':' +
              ' ' +
              action.title;
          }
        });
      }
      this.sessionActions = sessionActions.filter((item) => item.type !== SessionActionType.PartialSubmit);
      this.getFullUrls();
    } else {
      this.sessionActions = [];
    }
  }

  public getFullUrls(): void {
    for (const action of this.sessionActions) {
      if (action.url) {
        let fullUrl = '';
        const path = action.url.split('?');
        if (this._accountDetails.previewUrl) {
          fullUrl = this._accountDetails.previewUrl + path[0];
        } else {
          fullUrl = this._accountDetails.urls[0] + path[0];
        }
        if (!fullUrl.startsWith('http')) {
          fullUrl = 'https://' + fullUrl;
        }
        action.fullUrl = fullUrl;
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.personSubscription, this.sessionSubscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
